import { useQuery } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import type { GetProductDiscountGroupsResponse } from '@erp/rpc';

/**
 * Hook for fetching product discount groups for the current organization.
 * Used in discount creation forms for the PRODUCT_DISCOUNT_GROUP target type.
 */
export function useProductDiscountGroups() {
  const query = useQuery<GetProductDiscountGroupsResponse, Error>({
    queryKey:
      orpc.accountsReceivable.discounts.getProductDiscountGroups.queryKey({}),
    queryFn: async () => {
      return await rpcClient.accountsReceivable.discounts.getProductDiscountGroups();
    },
  });

  const groups = query.data?.groups ?? [];

  return {
    ...query,
    groups,
  } as typeof query & {
    groups: GetProductDiscountGroupsResponse['groups'];
  };
}
